import React, { useState, useEffect } from 'react';
import { Grid, TextField, MenuItem } from '@material-ui/core';
import { INTERESADO_BIENESTAR, ENTIDADES_EXTERNAS_BIENESTAR } from '../../../helper';
import { cargarCatalogo } from '../../components/CargarCatalogoBienestar';
import { useFormValidation } from './useFormValidation';

// =============================
// STEP 1 COMPONENTE REAL
// =============================
const InformacionEmergencia = ({ state, onChange, onError, solicitud }) => {
  const { safeValue, safeError, conError } = useFormValidation(state);
  const [interesado, setInteresado] = useState([]);

  useEffect(() => {

    if (solicitud?.usuario_registro) {

            const usuario = solicitud.usuario_registro;

            const nombreCompleto = `
                ${usuario.primer_nombre || ''} 
                ${usuario.segundo_nombre || ''} 
                ${usuario.primer_apellido || ''} 
                ${usuario.segundo_apellido || ''}
            `.replace(/\s+/g, ' ').trim();

            onChange({
                target: {
                    name: 'nombre_completo',
                    value: nombreCompleto
                }
            });

            onChange({
                target: {
                    name: 'documento_identidad',
                    value: usuario.identificacion || ''
                }
            });

            onChange({
                target: {
                    name: 'numero_contacto',
                    value: usuario.celular || usuario.telefono || ''
                }
            });
    }

    const cargarTodo = async () => {
      await Promise.all([
        cargarCatalogo(INTERESADO_BIENESTAR, setInteresado),
      ]);
    };
    cargarTodo();
  }, []);

  return (
    <Grid container spacing={3}>

      <Grid item xs={12} md={6}>
        <TextField
          disabled
          fullWidth
          label="Nombre Completo"
          name="nombre_completo"
          value={safeValue('nombre_completo')}
          onChange={onChange}
          error={conError(safeError('nombre_completo'))}
          helperText={safeError('nombre_completo')}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          disabled
          fullWidth
          label="No. de documento"
          name="documento_identidad"
          value={safeValue('documento_identidad')}
          onChange={onChange}
          error={conError(safeError('documento_identidad'))}
          helperText={safeError('documento_identidad')}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Lugar de Expedición"
          name="lugar_expedicion"
          value={safeValue('lugar_expedicion')}
          onChange={onChange}
          error={conError(safeError('lugar_expedicion'))}
          helperText={safeError('lugar_expedicion')}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          select
          label="Tipo Usuario"
          name="tipo_usuario"
          value={safeValue('tipo_usuario')}
          onChange={onChange}
          error={conError(safeError('tipo_usuario'))}
          helperText={safeError('tipo_usuario')}
        >
          {interesado.map((opcion) => (
            <MenuItem key={opcion.value} value={opcion.label}>
              {opcion.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Número de contacto"
          name="numero_contacto"
          value={safeValue('numero_contacto')}
          onChange={onChange}
          error={conError(safeError('numero_contacto'))}
          helperText={safeError('numero_contacto')}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          label="Descripción sintética de la emergencia"
          name="descripcion_emergencia"
          value={safeValue('descripcion_emergencia')}
          onChange={onChange}
          error={conError(safeError('descripcion_emergencia'))}
          helperText={safeError('descripcion_emergencia')}
        />
      </Grid>

    </Grid>
  );
};


// =============================
// STEP 2 COMPONENTE REAL
// =============================
const AccionesRemisiones = ({ state, onChange, pintarSelect }) => {

  const { safeValue, safeError, conError } = useFormValidation(state);

  const [entidadesExt, setEntidadesExt] = useState([]);

  useEffect(() => {
    cargarCatalogo(ENTIDADES_EXTERNAS_BIENESTAR, setEntidadesExt);
  }, []);

  return (
    <Grid container spacing={3}>

      <Grid item xs={12} md={6}>
        {pintarSelect("Atención en salud física de emergencia.", "atencion_fisica", [
          { label: 'SÍ', value: 'SI' },
          { label: 'NO', value: 'NO' }
        ])}
      </Grid>

      <Grid item xs={12} md={6}>
        {pintarSelect("Remisión para atención hospitalaria.", "remision_hospitalaria", [
          { label: 'SÍ', value: 'SI' },
          { label: 'NO', value: 'NO' }
        ])}
      </Grid>

      <Grid item xs={12} md={6}>
        {pintarSelect("Atención en salud mental de emergencia.", "atencion_mental", [
          { label: 'SÍ', value: 'SI' },
          { label: 'NO', value: 'NO' }
        ])}
      </Grid>

      <Grid item xs={12} md={6}>
        {pintarSelect("Requiere articulación con entidades externas.", "articulo_externa", [
          { label: 'SÍ', value: 'SI' },
          { label: 'NO', value: 'NO' }
        ])}
      </Grid>

      {safeValue('articulo_externa') === 'SI' && (
        <>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              select
              label="Entidad externa"
              name="entidad_externa"
              value={safeValue('entidad_externa')}
              onChange={onChange}
              error={conError(safeError('entidad_externa'))}
              helperText={safeError('entidad_externa')}
            >
              {entidadesExt.map((opcion) => (
                <MenuItem key={opcion.value} value={opcion.label}>
                  {opcion.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {String(safeValue('entidad_externa')).trim().toUpperCase() === 'OTRA' && (
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Otra entidad externa"
                name="otra_entidad_externa"
                value={safeValue('otra_entidad_externa')}
                onChange={onChange}
                error={conError(safeError('otra_entidad_externa'))}
                helperText={safeError('otra_entidad_externa')}
              />
            </Grid>
          )}
        </>
      )}

    </Grid>
  );
};


// =============================
// EXPORT STEPS
// =============================
export const Formulario001Steps = [
  {
    label: 'Información del Usuario y Detalle de la Emergencia',
    render: (props) => <InformacionEmergencia {...props} />
  },
  {
    label: 'Acciones y Remisiones',
    render: (props) => <AccionesRemisiones {...props} />
  }
];